import { render, staticRenderFns } from "./SalesRevenueDetailDownload.vue?vue&type=template&id=93cc4374&scoped=true"
import script from "./SalesRevenueDetailDownload.vue?vue&type=script&lang=js"
export * from "./SalesRevenueDetailDownload.vue?vue&type=script&lang=js"
import style0 from "./SalesRevenueDetailDownload.vue?vue&type=style&index=0&id=93cc4374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cc4374",
  null
  
)

export default component.exports